import {RouteRecordRaw} from "vue-router";
import PatientTopNavigation from "@/patient-administration/views/PatientTopNavigation.vue";
import PatientAdministrationHome from "@/patient-administration/views/PatientAdministrationHome.vue";
import PatientDashboardScreen from "@/patient-administration/views/PatientDashboardScreen.vue";
import OrdersScreen from "@/order/views/OrdersScreen.vue";
import PrescriptionRenewalIndexScreen from "@/prescription/views/PrescriptionRenewalIndexScreen.vue";
import PrescriptionRenewalPlanIndexScreen from "@/prescription/views/PrescriptionRenewalPlanIndexScreen.vue";
import PrescriptionRenewalPlanShowScreen from "@/prescription/views/PrescriptionRenewalPlanShowScreen.vue";
import PrescriptionRenewalPlanEditScreen from "@/prescription/views/PrescriptionRenewalPlanEditScreen.vue";
import PatientAdministrationApplicationView
    from "@/patient-administration/views/PatientAdministrationApplicationView.vue";
import SurveysView from "@/survey/views/SurveysView.vue";
import OffersView from "@/offer/views/OffersView.vue";
import OfferDetailsView from "@/offer/views/OfferDetailsView.vue";
import communicationRouter from "@/communication/communicationRouter";
import birthdayGiftRouter from "@/birthday-gift/birthdayGiftRouter";
import PatientAdministrationClickCollect from "@/patient-administration/views/PatientAdministrationClickCollect.vue";
import PatientAdministrationAttachmentsScreen
    from "@/patient-administration/views/PatientAdministrationAttachmentsScreen.vue";
import PatientAdministrationCertifiedCustomerScreen
    from "@/patient-administration/views/PatientAdministrationCertifiedCustomerScreen.vue";
import PatientAdministrationPendingCertificationScreen
    from "@/patient-administration/views/PatientAdministrationPendingCertificationScreen.vue";
import PatientVisitsScreen from "@/patient-administration/views/PatientVisitsScreen.vue";

const routes: RouteRecordRaw[] = [
    {
        path: '/patient-administration',
        name: 'patient-administration',
        component: PatientTopNavigation,
        meta: {
            title: 'Relation patients'
        },
        children: [
            {
                path: 'home',
                name: 'patient-administration.home',
                component: PatientAdministrationHome
            },
            {
                path: 'dashboard',
                name: 'patient-administration.dashboard',
                component: PatientDashboardScreen
            },
            {
                path: 'visits',
                name: 'patient-administration.visits',
                component: PatientVisitsScreen
            },
            {
                path: 'click-collect',
                name: 'patient-administration.click-collect',
                component: PatientAdministrationClickCollect
            },
            {
                path: 'orders',
                name: 'patient-administration.orders',
                component: OrdersScreen
            },
            {
                path: 'renewals',
                name: 'patient-administration.renewal.index',
                component: PrescriptionRenewalIndexScreen
            },
            {
                path: 'renewal-plans',
                name: 'patient-administration.renewal-plans.index',
                component: PrescriptionRenewalPlanIndexScreen
            },
            {
                path: 'renewals/:prescriptionId',
                name: 'patient-administration.renewal.show',
                component: PrescriptionRenewalPlanShowScreen
            },
            {
                path: 'renewals/:prescriptionId/edit',
                name: 'patient-administration.renewal.edit',
                component: PrescriptionRenewalPlanEditScreen
            },
            {
                path: 'application',
                name: 'patient-administration.application',
                component: PatientAdministrationApplicationView
            },
            {
                path: 'application/certified-customers',
                name: 'patient-administration.application.certified-customers',
                component: PatientAdministrationCertifiedCustomerScreen
            },
            {
                path: 'application/pending-customers',
                name: 'patient-administration.application.pending-customers',
                component: PatientAdministrationPendingCertificationScreen
            },
            {
                path: 'application/attachments',
                name: 'patient-administration.application.attachments',
                component: PatientAdministrationAttachmentsScreen,
            },
            {
                path: 'surveys',
                name: 'patient-administration.surveys',
                component: SurveysView
            },
            {
                path: 'offers',
                name: 'patient-administration.offers',
                component: OffersView
            },
            {
                path: 'detail/:offerId',
                name: 'patient-administration.offers.detail',
                component: OfferDetailsView
            },
            ...communicationRouter,
            ...birthdayGiftRouter
        ]
    },
];

export default routes;
